(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cantine-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const container = document.querySelector('.cantine-list');
    if (!container) return;

    container.addEventListener('click', function (e) {
      const link = e.target.closest('.vendor-list-letter-link');
      if (!link) return;

      e.preventDefault();
      const letter = link.getAttribute('data-letter');
      if (!letter) return;

      const target = document.getElementById('cantine-' + letter);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-adv-banners"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vendor-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const container = document.querySelector('.vendor-list');
    if (!container) return;

    container.addEventListener('click', function (e) {
      const link = e.target.closest('.vendor-list-letter-link');
      if (!link) return;

      e.preventDefault();
      const letter = link.getAttribute('data-letter');
      if (!letter) return;

      const target = document.getElementById(letter);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
